/* eslint-disable */
import React, { useRef, useEffect, useState, useContext } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import pad from 'pad';
import Barcode from 'react-barcode';
import utils from '../../../utils/utils.functions';
import masterFunction from '../master.functions';
import { ConfigContext } from '../../../context/config.context';
import {
  Dropdown,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
 faFileAlt
} from '@fortawesome/free-solid-svg-icons';
import notification from '../../../components/notification.component';

class ComponentToPrint extends React.Component {

  render() {
    const { guides, prefijo, empresa, currency, showPrefixGuide } = this.props;
    return (
    <div ref={this.props.propsRef}>
    {guides.map((guide, index) => {
     return <React.Fragment key={index}>
      <div style={{ padding: 10, minHeight: 1235 }} className="printElement1">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: 10,
            marginTop: 3,
          }}
        >
          <div style={{ textAlign: "left", marginBottom: 3 }}>
            <h3>ORDEN DE ENTREGA</h3>
            <Barcode value={guide.uuid} height={25} width={1} margin={0} />
          </div>
          <div style={{ textAlign: "right" }}>
              <small style={{ padding: 0 }}>Empresa:</small>
              <div style={{ fontWeight: 'bold' }}>{empresa.nombre_empresa}</div>
            </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: 10,
            marginTop: 3
          }}
        >
          <div>
            <div style={{ textAlign: "left" }}>
              <small style={{ padding: 0 }}>Registrado</small>
              <div>{moment(guide.createdAt).format('DD/MM/YYYY H:m:s')}</div>
            </div>
            <div style={{ textAlign: "left" }}>
              <small style={{ padding: 0 }}>Gui master</small>
              <div>{pad(5,guide.master_guia.id,'0')}</div>
            </div>
            <div style={{ textAlign: "left" }}>
              <small style={{ padding: 0 }}>Guia paquete</small>
              <div style={{ fontSize: 20, fontWeight: 'bold' }}>{showPrefixGuide ? guide.master_guia.rel_tipos.prefijo : prefijo}-{guide.guia_paquete}</div>
            </div>
            <div style={{ textAlign: "left" }}>
              <small style={{ padding: 0 }}>Tipo de envio</small>
              <div>{guide.master_guia.rel_tipos.description}</div>
            </div>
            <div style={{ textAlign: "left" }}>
              <small style={{ padding: 0 }}>Bultos</small>
              <div>{guide.bultos.length}</div>
            </div>
          </div>
          <div>
            <div style={{ textAlign: "right" }}>
              <small style={{ padding: 0 }}>Remitente</small>
              <div>{guide.cliente.name}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <small style={{ padding: 0 }}>Destinatario</small>
              <div>{guide.cliente_receptor_nombre}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <small style={{ padding: 0 }}>Identificación</small>
              <div>{guide.cliente_receptor_identificacion}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <small style={{ padding: 0 }}>Telefono</small>
              <div>{guide.cliente_receptor_telefono}</div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: 10,
            marginTop: 3
          }}
        >
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Dirección de entrega</small>
            <div>{guide.cliente_receptor_direccion_entrega.toUpperCase()} - {guide.estado_guia.estado !== '-' && guide.estado_guia.estado.toUpperCase()} {guide.ciudad_guia.ciudad !== '-' && guide.ciudad_guia.ciudad.toUpperCase()} {guide.pais_guia.country}</div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: 10,
            marginTop: 3
          }}
        >
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Bultos</small>
            {guide.bultos.map((bulto) => {
            return  <div key={bulto.id} style={{ display: "flex", flexDirection: "column" }}>
                <div>{bulto.alto} * {bulto.ancho} * {bulto.largo} - {bulto.peso} Kg</div>
              </div>
            })
            }
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: 10,
            marginTop: 3
          }}
        >
          <div style={{ textAlign: "left", width: "100%" }}>
            <small style={{ padding: 0 }}>Detalle productos</small>
            {guide.detalle.length ? 
              <div style={{ display: "flex", flexWrap: 'wrap' }}>
                {guide.detalle.map((articulo) => {  
                  return  <div key={articulo.id} style={{ fontSize: 11, paddingLeft: 5 }}> 
                    ({articulo.cantidad}) {articulo.descripcion},
                  </div>
                })}
              </div>
            :
            <div style={{ width: "100%", textAlign: "center" }}>
              No Aplica
            </div>
            }
          </div>
        </div>
        { /* 
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: 10,
            marginTop: 3
          }}
        >
        <div style={{ textAlign: "letf" }}>
        <small style={{ padding: 0 }}>Seguro</small>
        {guide.seguro_guia.length ?
            guide.seguro_guia.map((e, i) => {
              return <div key={i} style={{ display: 'flex' }}>
                        <div style={{ marginRight: 10 }}>Monto de carga: {utils.formatMoney(e.monto_carga)}</div>   
                        <div style={{ marginRight: 10 }}>Asegurado por: {utils.formatMoney(e.monto_seguro)}</div>   
                    </div>
            })
          :  <div style={{ width: "100%", textAlign: "center" }}>
                Guia no asegurada
            </div> }
          </div>
        </div> 
        */}
 { /* 
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: 10,
            marginTop: 3
          }}
        >
        <div style={{ textAlign: "letf" }}>
        <small style={{ padding: 0 }}>Desglose pago</small>
          {guide.pagos_guia.map((e, i) => {
            return <div key={i} style={{ display: 'flex' }}>
                      <div style={{ marginRight: 10 }}>{utils.formatMoney(e.monto_pago)}</div>   
                      <div style={{ marginRight: 10 }}>{e.tipo_pago.description}</div>   
                      <div style={{ marginRight: 10 }}>{e.referencia ? e.referencia : 'N/A'}</div>               
                  </div>
          })}
        </div>
        <div style={{ textAlign: "letf" }}>
            <small style={{ padding: 0 }}>Total pagado</small>
        <div>{utils.formatMoney(guide.monto_pago)} {currency}</div>
        </div>
        </div>
      */}
        <div>
          <h3>Información de entrega</h3>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            padding: 10,
            marginTop: 3
          }}
        >
          <div>
            <div style={{  height: 40, fontWeight: 'bold'  }}>Fecha</div>
            <div >___/___/____</div>
          </div>
          <div>
            <div style={{  height: 40, fontWeight: 'bold'  }}>Hora</div>
            <div >___:___</div>
          </div>
          <div>
            <div style={{ height: 40, fontWeight: 'bold' }}>Nro. Cedula</div>
            <div>_________________________________</div>
          </div>
          <div>
            <div style={{  height: 40, fontWeight: 'bold'  }}>Recibe conforme</div>
            <div>__________________________________</div>
          </div>
        </div>
      </div>
      <div style={{ breakAfter: 'page' }}></div>
      </ React.Fragment>
     })}
      </div>
    );
  }
}
 
const PrinterFullEntrega = ({ masterId, campo, texto, disabled, isButton = false, showPrefixGuide }) => {

  const { config } = useContext(ConfigContext);
  const [guias, setGuias] = useState([]);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    bodyClass: "printElement1",
  });

  const getOrdenes = () => {
    notification.success('Espere un momento, generado documento.')
    masterFunction.ordenesEntrega({ 
      [campo]: masterId
    }).then((response) => {
      if (response.length) {
        setGuias(response);
      } else {
        notification.warning('La guia master no posee guias registradas.');
      }
    })
  }
  
  useEffect(() => {
    if (guias.length) {
        handlePrint();
    }
  }, [guias]);

  return (
    <div>
      <div style={{ display: 'none'}}>
       {<ComponentToPrint 
          guides={guias}
          empresa={config}
          prefijo={config.prefijo_correlativo_guia}
          currency={config.currency}
          propsRef={componentRef}
          showPrefixGuide={showPrefixGuide}
        />}
      </div>
      {isButton ? 
        <button onClick={getOrdenes} disabled={disabled} type="button" className="btnx btnx-warn mr-1">
          <FontAwesomeIcon icon={faFileAlt} /> Orden de entrega
        </button>
        :
        <Dropdown.Item disabled={disabled} onClick={getOrdenes}>
          <FontAwesomeIcon icon={faFileAlt} /> { texto || 'Ordenes de entrega' }
        </Dropdown.Item>
      }
    </div>
  );
};

export default PrinterFullEntrega;